import { useAutoCreatePrivyEmbeddedWallet } from './useAutoCreatePrivyEmbeddedWallet';
import useRestorePrivyNativeSession from 'src/hooks/globalSyncs/wallet/useRestorePrivyNativeSession';
import { useSyncPrivyLogout } from './useSyncPrivyLogout';
import { useSyncPrivyWalletMapping } from 'src/hooks/wallets/privy/mappings/useSyncPrivyWalletMapping';
import { useDisableEmbeddedWalletForBlacklistedWallets } from './useDisableEmbeddedWalletForBlacklistedWallets';

export const useSyncPrivy = () => {
	useAutoCreatePrivyEmbeddedWallet();
	useRestorePrivyNativeSession();
	useSyncPrivyLogout();
	useSyncPrivyWalletMapping();
	useDisableEmbeddedWalletForBlacklistedWallets();
};
